import { useEffect, useState } from "react";
import { HealthPlan } from "../../../utils/api-objects/meal-plan";
import { getHealthPlansByUserId } from "../../../utils/apis/plan-service";
import { useAuth } from "../../../utils/context/AuthContext";

export const useGetHealthPlans = (patientId: string | null) => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [healthPlans, setHealthPlans] = useState<HealthPlan[]>();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        const fetchHealthPlans = async () => {
            if (!patientId || !idToken) return;

            setIsLoading(true);
            try {
                const plans = await getHealthPlansByUserId(patientId, idToken);
                setHealthPlans(plans);
            } catch (error) {
                console.error("Errore nel caricamento degli health plans:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchHealthPlans();
    }, [patientId, idToken]);

    return { healthPlans, isLoading };
}